"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearWorkspaceCatalogWithAvailableItems = void 0;
// (C) 2019-2020 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var BearWorkspaceCatalogWithAvailableItems = /** @class */ (function () {
    function BearWorkspaceCatalogWithAvailableItems(catalogGroups, items, availableItems) {
        this.catalogGroups = catalogGroups;
        this.items = items;
        this.availableItems = availableItems;
    }
    BearWorkspaceCatalogWithAvailableItems.prototype.groups = function () {
        return this.catalogGroups;
    };
    BearWorkspaceCatalogWithAvailableItems.prototype.allItems = function () {
        return this.items;
    };
    BearWorkspaceCatalogWithAvailableItems.prototype.attributes = function () {
        return this.items.filter(sdk_backend_spi_1.isCatalogAttribute);
    };
    BearWorkspaceCatalogWithAvailableItems.prototype.measures = function () {
        return this.items.filter(sdk_backend_spi_1.isCatalogMeasure);
    };
    BearWorkspaceCatalogWithAvailableItems.prototype.facts = function () {
        return this.items.filter(sdk_backend_spi_1.isCatalogFact);
    };
    BearWorkspaceCatalogWithAvailableItems.prototype.dateDatasets = function () {
        return this.items.filter(sdk_backend_spi_1.isCatalogDateDataset);
    };
    BearWorkspaceCatalogWithAvailableItems.prototype.allAvailableItems = function () {
        return this.availableItems;
    };
    BearWorkspaceCatalogWithAvailableItems.prototype.availableAttributes = function () {
        return this.availableItems.filter(sdk_backend_spi_1.isCatalogAttribute);
    };
    BearWorkspaceCatalogWithAvailableItems.prototype.availableMeasures = function () {
        return this.availableItems.filter(sdk_backend_spi_1.isCatalogMeasure);
    };
    BearWorkspaceCatalogWithAvailableItems.prototype.availableFacts = function () {
        return this.availableItems.filter(sdk_backend_spi_1.isCatalogFact);
    };
    BearWorkspaceCatalogWithAvailableItems.prototype.availableDateDatasets = function () {
        return this.availableItems.filter(sdk_backend_spi_1.isCatalogDateDataset);
    };
    return BearWorkspaceCatalogWithAvailableItems;
}());
exports.BearWorkspaceCatalogWithAvailableItems = BearWorkspaceCatalogWithAvailableItems;
//# sourceMappingURL=catalogWithAvailableItems.js.map